import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const MEDICATIONS_QUERY_KEY = "medicationsQuery";

export const useMedicationsQuery = (patientUserId) => {
  return useQuery({
    queryKey: [MEDICATIONS_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: getAllMedications.bind(this, patientUserId),
    placeholderData: [],
    enabled: !!patientUserId,
  });
};

export const useMedicationQuery = (id, patientUserId) => {
  return useQuery({
    queryKey: [MEDICATIONS_QUERY_KEY, id, patientUserId],
    retry: false,
    queryFn: getAllMedications.bind(this, patientUserId),
    enabled: !!patientUserId && !!id,
    select: (medications) => {
      const medication = medications.filter((m) => m.id === id)[0];
      if (medication) {
        return {
          ...medication,
          beginDate: medication.beginDate?.replace(/-/g, "/") ?? "",
          endDate: medication.endDate?.replace(/-/g, "/") ?? "",
        };
      }
      return null;
    },
  });
};

const getAllMedications = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "pcmedapi",
    path: "/medications/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
